// The default title appears in frontend/public/index.html and as
// SITE_DEFAULT_TITLE in backend/services/seo_static_pages.py; the suffix is
// TITLE_SUFFIX in backend/services/seo_page_head.py. Change every copy together.
export const SITE_DEFAULT_TITLE = 'Belhop - Luxury Concierge Services';
export const DOCUMENT_TITLE_SUFFIX = ' | Belhop';
